import { render } from "./CollapseHeight.vue?vue&type=template&id=3150feee"
import script from "./CollapseHeight.vue?vue&type=script&lang=js"
export * from "./CollapseHeight.vue?vue&type=script&lang=js"

import exportComponent from "/data/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__